module.exports = __webpack_public_path__ + "static/media/vector-square.6ca6b304.svg";